<template>
  <div class="flex flex-col">

    <div v-if="!boatId && boatName">
      <div class="text-red-700 py-1">Customer provided a new boat name. Please verify and add and update the selected boat.</div>
      <div class="w-auto px-4 py-3 border rounded border-gray-300">{{ boatName }}</div>

      <p class="text-sm font-bold mt-3">SELECT BOAT</p>
    </div>

    <div class="flex-1">
        <v-select :disabled="disabled" v-model="form.boatId" label="name" :options="boatList" aria-required="true" required :reduce="boat => boat.id">

          <template v-slot:option="option">
            {{ option.name }} <span v-if="option.alt_name" class="text-gray-400 ml-2 text-sm">{{ option.alt_name }}</span>
          </template>

          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              No match found.
              <div>
                <button class="btn btn-gray px-1 py-1" @click.prevent="showAddNewBoatForm">Click here to create new boat</button>
              </div>

            </template>
            <em style="opacity: 0.5;" v-else>Select or type to search...</em>
          </template>

          <template #search="{attributes, events}">
            <input
              class="vs__search"
              :required="!form.boat"
              v-bind="attributes"
              v-on="events"
            />
          </template>
        </v-select>
      <div v-if="errors" class="text-red-500 p-1 text-sm mb-2">
        {{ errors.join(', ') }}
      </div>
    </div>

    <div v-if="showNewBoatForm" class="grid grid-cols-2 bg-white p-4 border rounded shadow z-50">

      <text-input v-model="newBoat.name" :errors="$page.props.errors.name" class="pr-6 pb-8" label="Boat Name" />
      <text-input v-model="newBoat.primary_mobile" :errors="$page.props.errors.name" class="pr-6 pb-8" label="Primary Mobile" />
      <button class="btn btn-gray p-2 rounded mt-3" @click="addNewBoat">Add New Boat</button>
    </div>

    <div v-if="selectedBoat" class="flex flex-row my-2">
      <div class="bg-gray-200 rounded-md p-2 text-sm">{{ selectedBoat.name }} <span v-if="selectedBoat.alt_name">/ {{ selectedBoat.alt_name }}</span> </div>
      <div class="bg-gray-200 rounded-md p-2 text-sm mx-3">📞 {{ selectedBoat.primary_mobile }} <span v-if="selectedBoat.secondary_mobile">/ {{ selectedBoat.secondary_mobile }}</span></div>
    </div>

  </div>
</template>

<script>

import TextInput from '@/Shared/TextInput'

export default {
  name: 'DeliveryToBoat',
  components: { TextInput },
  props: {
    boatId: Number,
    boatName: String,
    errors: String,
    disabled: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      boatList : [],
      form: {
        boatId: this.boatId
      },
      showNewBoatForm: false,
      newBoat: {
        name: null,
        primary_mobile: null,
      }
    }
  },

  watch: {
    'form.boatId': function() {

      let boatName = null;
      if(this.selectedBoat) {
        boatName = this.selectedBoat.name;
        if(this.selectedBoat.alt_name) {
          boatName = boatName + ' - ' + this.selectedBoat.alt_name
        }
      }
      this.$emit('change', {
        id: this.form.boatId,
        name: boatName
      })
    }
  },

  computed: {
    selectedBoat(){
      if(this.form.boatId) {
        return this.boatList.find(boat => boat.id == this.form.boatId)
      }

      return null
    }
  },

  mounted() {
    this.$http.get(this.route('ajax.boat-list')).then(response => {
      this.boatList = response.data
    });
  },

  methods: {
    showAddNewBoatForm() {
      this.form.boatId = null
      this.showNewBoatForm = true
    },

    addNewBoat() {
      this.$http.post(this.route('ajax.boat-add'), {
        name: this.newBoat.name,
        primary_mobile: this.newBoat.primary_mobile
      }).then(response => {
        this.boatList.push(response.data)
        return response.data;
      }).then(boat => {
        this.form.boatId = boat.id
        this.showNewBoatForm = false;
      })

    }
  }


}
</script>
